import { render, staticRenderFns } from "./AddFacultyDepartmentModal.vue?vue&type=template&id=0492fc90&scoped=true"
import script from "./AddFacultyDepartmentModal.vue?vue&type=script&lang=js"
export * from "./AddFacultyDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./AddFacultyDepartmentModal.vue?vue&type=style&index=0&id=0492fc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492fc90",
  null
  
)

export default component.exports